module.exports = __webpack_public_path__ + "static/img/3712_phase_function_Paper_Points.bbf474e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3712_phase_function_Paper_Points.png
// module id = JxDK
// module chunks = 0